import { runPortal } from '@piral/portal-core';
import { lazy } from 'react';
function showError(code) {
    const messages = {
        '401': 'The authentication method seems to be not working.',
        '500': 'Something is not working right internally.',
    };
    const message = messages[code] || '';
    document.querySelector('#app').innerHTML = `
    <section class="container topbar anonymous">
      <p></p>
    </section>
    <div class="content">
      <div class="shout text-center">
        <h2>${code}</h2>
        <h3>Oh no! Something went wrong.</h3>
        <p>Make sure to check the settings of the Piral Feed Service. ${message} The logs should give you more information.</p>
      </div>
    </div>
  `;
}
function start() {
    if (window.CLOUD_HAS_ERROR) {
        showError(500);
    }
    else {
        const portalUrl = window.CLOUD_WWW_ADDRESS || document.location.origin;
        const apiUrl = window.CLOUD_API_ADDRESS || portalUrl;
        const consent = window.CLOUD_SHOW_CONSENT || false;
        const root = window.CLOUD_SHOW_HOME ? () => import('./Home') : () => import('./Login');
        runPortal({
            apiUrl,
            portalUrl,
            consent,
            components: {},
            providers: [window.CLOUD_AUTH_PROVIDER],
            pages: {
                '/': lazy(root),
            },
            plans: ['premium'],
        });
    }
}
if (process.env.NODE_ENV === 'development') {
    const baseElement = document.head.appendChild(document.createElement('base'));
    baseElement.href = location.origin;
}
__webpack_public_path__ = document.querySelector('base').href;
start();
